import ContaCorrenteProps from './ContaCorrenteProps';
import ContaNaoCorrenteProps from './ContaNaoCorrenteProps';

export const GerencianetContaCorrenteProps = ContaCorrenteProps;
export const GerencianetContaNaoCorrenteProps = ContaNaoCorrenteProps;
